
export default {
  created () {
  },

  mounted () {
  },

  computed: {
  },

  filters: {
  },

  data () {
    return {
      popoverVisible: false,
      popoverTarget: null,
      popoverDirection: 'up',
      coverTarget: false,
      helpMessage: ''
    }
  },

  methods: {
    showPopover (event, direction, coverTarget, message) {
      this.popoverTarget = event
      this.popoverDirection = direction
      this.coverTarget = coverTarget
      this.popoverVisible = true
      this.helpMessage = message
      // console.log('message', message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/com_help.js